import clsx from 'clsx'
import React from 'react'

function Logo(props) {
  const { className } = props

  return (
    <img
      alt='PSA Logo'
      src='/na-mig/static/psa-logo.png'
      className={clsx('logo-gets', className)}
      style={{ width: 'auto' }}
    />
  )
}

export default Logo
